import React from 'react';
import { Neo, NeoGrid, Views } from '@singularsystems/neo-react';
import SecurityTransfersVM from './SecurityTransfersVM';
import { observer } from 'mobx-react';
import { TextConstants } from '../../../Common/TextConstants';
import SecurityTransferLookup from '../Models/Lookups/SecurityTransferLookup';
import ManageSecurityTransferComponent from '../components/ManageSecurityTransferComponent';
import Loading from '../../../App/Components/Loading/Loading';
import { SecurityTransfers } from '../../../AccessControl/Models/Commands/Security/Roles';

@observer
export default class SecurityTransfersView extends Views.ViewBase<SecurityTransfersVM> {

    constructor(props: unknown) {
        super("Security Transfers", SecurityTransfersVM, props);
    }

    public render() {
        return (
            <>
                {(this.viewModel.taskRunner.isBusy) && <Loading />}
                {this.viewModel.showManageSecurityTransferComponent &&
                    <ManageSecurityTransferComponent
                        viewModel={this.viewModel.manageSecurityTransferComponentVM}
                        onSave={() => this.viewModel.saveSecurityTransfer()}
                        onCancel={() => this.viewModel.cancel()} />}

                {this.viewModel.showManageSecurityTransferComponent === false &&
                    <Neo.Card title={TextConstants.Titles.SecurityTransfers} className="m-1">
                        {this.viewModel.authorisationService.hasRole(SecurityTransfers.AddNew) &&
                            <div className="row pb-3">
                                <div className="col text-right">
                                    <Neo.Button
                                        onClick={() => this.viewModel.addSecurityTransfer()}
                                        variant="primary" size="sm"
                                    >{TextConstants.Buttons.AddSecurityTransfer}</Neo.Button>
                                </div>
                            </div>
                        }
                        <Neo.Form onSubmit={() => this.viewModel.securityTransferSearchCritera.meta.searchCriteria.value === "" ? this.viewModel.pageManager.refreshData() : this.viewModel.clearSearch()}>
                            <Neo.FormGroup
                                suppressLabel={true}
                                bind={this.viewModel.securityTransferSearchCritera.meta.searchCriteria}
                                placeholder={TextConstants.PlaceHolder.SearchSecurityTransfersCriteria}
                                append={
                                    <Neo.Button isSubmit>
                                        <i className={`${this.viewModel.securityTransferSearchCritera.meta.searchCriteria.value === "" ? "fa fa-search" : "fa fa-times-circle"}`} />
                                    </Neo.Button>}
                            />
                        </Neo.Form>
                        <Neo.Pager pageManager={this.viewModel.pageManager} pageControlProps={{ pageSizeLabel: "Show:" }}>
                            <div className="horizontalScroll inner-container">
                                {this.viewModel.pageManager.totalRecords > 0 &&
                                    <NeoGrid.Grid<SecurityTransferLookup> className={"table-striped"}>
                                        {(item, meta) => (
                                            <NeoGrid.Row key={item.securityTransferID}>
                                                <NeoGrid.Column display={meta.transferEntryDate} />
                                                <NeoGrid.Column display={meta.brokerAccountFrom} />
                                                <NeoGrid.Column display={meta.brokerAccountTo} />
                                                <NeoGrid.Column display={meta.clientPolicyNumber} />
                                                <NeoGrid.Column display={meta.clientName} />
                                                <NeoGrid.Column display={meta.isTaxableTransferInd} label={TextConstants.Labels.TaxableTransfer} />
                                                <NeoGrid.Column display={meta.executionDate} />
                                                <NeoGrid.Column display={meta.isExternalInd} label={TextConstants.Labels.ExternalTransfer} />
                                                <NeoGrid.Column display={meta.notes} />
                                                {this.viewModel.authorisationService.hasRole(SecurityTransfers.Edit) &&
                                                    <NeoGrid.ButtonColumn label={TextConstants.Labels.Edit} className="text-center">
                                                        <Neo.Button
                                                            onClick={() => this.viewModel.editSecurityTransfer(item)}
                                                            variant="primary" isOutline className="btn-small">
                                                            <i className="fa fa-edit"></i>
                                                        </Neo.Button>
                                                    </NeoGrid.ButtonColumn>
                                                }
                                                {this.viewModel.authorisationService.hasRole(SecurityTransfers.Delete) &&
                                                    <NeoGrid.ButtonColumn label={TextConstants.Labels.Delete} className="text-center">
                                                        <Neo.Button
                                                            onClick={() => this.viewModel.displayDeleteSecurityTransferModal(item)}
                                                            variant="primary" isOutline className="btn-small">
                                                            <i className="fa fa-trash"></i>
                                                        </Neo.Button>
                                                    </NeoGrid.ButtonColumn>
                                                }
                                            </NeoGrid.Row>
                                        )}
                                    </NeoGrid.Grid>
                                }
                                {this.viewModel.pageManager.totalRecords === 0 &&
                                    <div className="col-md-12 p=0 text-center">
                                        {TextConstants.GeneralText.NoRecords}
                                    </div>
                                }
                            </div>
                        </Neo.Pager>
                    </Neo.Card>
                }
                {this.viewModel.showDeleteSecurityTransferModal && this.viewModel.authorisationService.hasRole(SecurityTransfers.Delete) &&
                    <Neo.Modal
                        title={TextConstants.Titles.DeleteSecurityTransfer}
                        bind={this.viewModel.meta.deletingSecurityTransfer}
                        closeButton={{ text: "No", variant: "secondary", isOutline: true, onClick: () => this.viewModel.cancelDeleteSecurityTransfer() }}
                        acceptButton={{ text: "Yes", variant: "primary", onClick: () => { this.viewModel.deleteSecurityTransfer() } }}>
                        {TextConstants.GeneralText.DeleteSecurityTransferConfirmation}
                    </Neo.Modal>
                }
            </>
        );
    }
}